import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './utils/lang_provider';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import { ConfigProvider } from 'antd';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <LanguageProvider>
      <ConfigProvider 
        theme={{
          token: {
            colorSplit: "rgba(5,5,5,0.06)",
          },
          components: {
            Breadcrumb: {
                linkColor: "#ebd7d7",
                separatorColor: "#ebd7d7"
            },
            Skeleton: {
              gradientFromColor: "rgba(0,0,0,0.15)",
              gradientToColor: "rgba(0,0,0,0.5)"
            },
            Menu : {
              itemBorderRadius: 0,
              itemColor: "rgb(103, 96, 96)",
              horizontalItemSelectedColor: "rgb(202, 48, 48)",
              horizontalItemHoverColor: "rgb(202, 48, 48)",
              itemSelectedColor: "rgb(202, 48, 48)",
              itemHoverColor: "rgb(202, 48, 48)",
            }
          }
        }}>
      <Router>
        <App />
      </Router>
        </ConfigProvider>
    </LanguageProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
